import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const SHARING_TEMPLATE_PATH = "/sharing-templates/v1";

/**
 * Get all sharing templates with pagination and search
 * @param {Object} params - Query parameters (page, limit, search)
 * @returns {Promise<{data: Array, total: number, success: boolean}>}
 */
export const getSharingTemplatesApi = async (params = {}) => {
  try {
    const queryParams = {
      page: params.page || 1,
      limit: params.limit || 10,
      ...(params.search && { templateName: params.search })
    };
    
    const response = await getRequest(SHARING_TEMPLATE_PATH, queryParams);
    
    let responseData = response?.data || [];
    
    if (params.search && params.search.trim() !== '') {
      const searchTerm = params.search.trim().toLowerCase();
      responseData = responseData.filter(template => 
        template.templateName && 
        typeof template.templateName === 'string' &&
        template.templateName.toLowerCase().includes(searchTerm)
      );
    }
    
    const total = responseData.length;
    
    return {
      data: Array.isArray(responseData) ? responseData : [],
      count: total,
      success: response?.success || false,
    };
  } catch (error) {
    console.error('Error in getSharingTemplatesApi:', error);
    const errorResult = {
      data: [],
      count: 0,
      success: false,
    };
    console.log('getSharingTemplatesApi error, returning:', errorResult);
    return errorResult;
  }
};

/**
 * Get a single sharing template by ID
 * @param {string} id - Template ID
 * @returns {Promise<Object>}
 */
export const getSharingTemplateByIdApi = async (id) => {
  const response = await getRequest(`${SHARING_TEMPLATE_PATH}/${id}`);
  return response?.data || null;
};

/**
 * Create a new sharing template
 * @param {Object} body - Template data
 * @returns {Promise<Object>}
 */
export const addSharingTemplateApi = async (body) => {
  const response = await postRequest(SHARING_TEMPLATE_PATH, body);
  return response?.data || null;
};

/**
 * Update an existing sharing template
 * @param {Object} body - Updated template data (must include _id)
 * @returns {Promise<Object>}
 */
export const updateSharingTemplateApi = async (body) => {
  if (!body?._id) throw new Error('Template ID is required');
  const response = await putRequest(`${SHARING_TEMPLATE_PATH}/${body._id}`, body);
  return response?.data || null;
};

/**
 * Delete a sharing template
 * @param {string} id - Template ID to delete
 * @returns {Promise<Object>}
 */
export const deleteSharingTemplateApi = async (id) => {
  const response = await deleteRequest(`${SHARING_TEMPLATE_PATH}/${id}`);
  return response?.success || false;
};

/**
 * Update template status (active/inactive)
 * @param {string} id - Template ID
 * @param {boolean} active - New status
 * @returns {Promise<Object>}
 */
export const updateTemplateStatusApi = async (id, active) => {
  const response = await putRequest(`${SHARING_TEMPLATE_PATH}/${id}/status`, { active });
  return response?.data || null;
};
